{
	"title": "Atributy zachycené uhlíkem",
	"buttonTitle": "Zachycování a ukládání uhlíku",
	"table": {
		"materialDescription": "Materiál",
		"quantity": "Množství",
		"productGwpTotal": "Celkový GWP produktu",
		"bundledCarbonReductions": "Souhrnné snížení uhlíku",
		"remainingGwp": "Zbývající GWP",
		"epdForPhysicalMaterial": "EPD pro fyzický materiál",
		"carbonPlantName": "Brevik, Norsko"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "je právoplatným držitelem hlášeného snížení uhlíku."
	},
	"modal": {
		"title": "Zachycování a ukládání uhlíku",
		"description": "Carbon Capture and Storage (CCS) je technologie, která dokáže zachycovat emise oxidu uhličitého (CO2) produkované kalcinačním procesem a používáním paliv v provozu pece, čímž zabraňuje vstupu oxidu uhličitého do atmosféry a jeho trvalému ukládání pod zem. Zachycený CO2 ze závodu Heidelberg Materials v Brevik, Norsko, je stlačen a transportován do úložiště pod Severním mořem. Zařízení v našem závodě v Breviku zachytí 400 000 tun CO2 ročně.",
		"showLink": "Zjistěte více o procesu zachycování uhlíku",
		"buttonClose": "Zavřít"
	},
	"footnote": "1) Snížení uhlíku kompenzuje fáze A1-A3 inventáře životního cyklu cementu."
}
